<template>
  <div>     
    <Mainlayout></Mainlayout>

    <CCard class="custom-card h-100 mt-5">      
      <CCol sm="12" class="justify-content-center">
        <CContainer>
          <CCol class="custom-margin">
            <br />
            <br />
            <br />
            <br />
            <br />

            <label class="mt-4"><strong>
            <img src="../assets/img/iconInfo.png" width="20px" height="20px"/>
            This coin can be used to view the correct answer. 1 coin will be deducted for each answer.
            </strong></label>
            <CRow>
              <h4 class="text-left mt-3 mb-4 bold col-10">
                Purchase Coin                
              </h4>
              <br />
            </CRow>

            

            <CRow>
              <CCol class="col-4" style="padding-right: 5px; padding-left: 5px">
                <CCard class="text-center justify-content-center coin_card" style="border-radius: 20px; background-color: #C4C4C4;">
                  <p class="mt-2" style="font-size: 17px; font-weight: 900; margin-bottom: 5px"><strong>25</strong></p>
                  <div class="text-center">
                    <img src="../assets/img/coin1.png" width="50px" height="50px"/>
                  </div>
                  <br />
                  <div class="text-center justify-content-center col-12" style="padding-left: 5px; padding-right: 5px;">
                    <CButton
                      style="
                        background-color: #466EFC; 
                        color: #FFFFFF;                       
                        border-radius:20px;  
                        font-size:16px;                                            
                        "
                      size="sm"
                      class="mb-2 col-12"
                      @click="GoToEwallet()"
                    ><strong>RM 5</strong></CButton>
                  </div>
                </CCard>
              </CCol>

              <CCol class="col-4" style="padding-right: 5px; padding-left: 5px">
                <CCard class="text-center justify-content-center coin_card" style="border-radius: 20px; background-color: #C4C4C4;">
                  <p class="mt-2" style="font-size: 17px; font-weight: 900; margin-bottom: 5px"><strong>50</strong></p>
                  <div class="text-center">
                    <img src="../assets/img/coin2.png" width="50px" height="50px"/>
                  </div>
                  <br />
                  <div class="text-center justify-content-center col-12" style="padding-left: 5px; padding-right: 5px;">
                    <CButton
                      style="
                        background-color: #466EFC; 
                        color: #FFFFFF;                       
                        border-radius:20px; 
                        font-size:16px;                     
                        "
                      size="sm"
                      class="mb-2 col-12"
                      @click="GoToEwallet()"
                    ><strong>RM 10</strong></CButton>
                  </div>
                </CCard>
              </CCol>

              <CCol class="col-4" style="padding-right: 5px; padding-left: 5px">
                <CCard class="text-center justify-content-center coin_card" style="border-radius: 20px; background-color: #C4C4C4;">
                  <p class="mt-2" style="font-size: 17px; font-weight: 900; margin-bottom: 5px"><strong>75</strong></p>
                  <div class="text-center">
                    <img src="../assets/img/coin3.png" width="50px" height="50px"/>
                  </div> 
                  <br />
                  <div class="text-center justify-content-center col-12" style="padding-left: 5px; padding-right: 5px;">
                    <CButton
                      style="
                        background-color: #466EFC; 
                        color: #FFFFFF;                       
                        border-radius:20px; 
                        font-size:16px;                     
                        "
                      size="sm"
                      class="mb-2 col-12"
                      @click="GoToEwallet()"
                    ><strong>RM 15</strong></CButton>
                  </div>
                </CCard>
              </CCol>              
            </CRow>

            <CRow>
              <CCol class="col-4" style="padding-right: 5px; padding-left: 5px">
                <CCard class="text-center justify-content-center coin_card2" style="border-radius: 20px; background-color: #C4C4C4;">
                  <p class="mt-2" style="font-size: 17px; font-weight: 900; margin-bottom: 5px"><strong>100</strong></p>
                  <div class="text-center">
                    <img src="../assets/img/coin3.png" width="50px" height="50px"/>
                  </div> 
                  <br />
                  <div class="text-center justify-content-center col-12" style="padding-left: 5px; padding-right: 5px;">
                    <CButton
                      style="
                        background-color: #466EFC; 
                        color: #FFFFFF;                       
                        border-radius:20px; 
                        font-size:16px;                     
                        "
                      size="sm"
                      class="mb-2 col-12"
                      @click="GoToEwallet()"
                    ><strong>RM 20</strong></CButton>
                  </div>
                </CCard>
              </CCol> 

              <CCol class="col-4" style="padding-right: 5px; padding-left: 5px">
                <CCard class="text-center justify-content-center coin_card2" style="border-radius: 20px; background-color: #C4C4C4;">
                  <p class="mt-2" style="font-size: 17px; font-weight: 900; margin-bottom: 5px"><strong>125</strong></p>
                  <div class="text-center">
                    <img src="../assets/img/coin3.png" width="50px" height="50px"/>
                  </div> 
                  <br />
                  <div class="text-center justify-content-center col-12" style="padding-left: 5px; padding-right: 5px;">
                    <CButton
                      style="
                        background-color: #466EFC; 
                        color: #FFFFFF;                       
                        border-radius:20px; 
                        font-size:16px;                     
                        "
                      size="sm"
                      class="mb-2 col-12"
                      @click="GoToEwallet()"
                    ><strong>RM 25</strong></CButton>
                  </div>
                </CCard>
              </CCol>         

              <CCol class="col-4" style="padding-right: 5px; padding-left: 5px">
                <CCard class="text-center justify-content-center coin_card2" style="border-radius: 20px; background-color: #C4C4C4;">
                  <p class="mt-2" style="font-size: 17px; font-weight: 900; margin-bottom: 5px"><strong>150</strong></p>
                  <div class="text-center">
                    <img src="../assets/img/coin3.png" width="50px" height="50px"/>
                  </div> 
                  <br />
                  <div class="text-center justify-content-center col-12" style="padding-left: 5px; padding-right: 5px;">
                    <CButton
                      style="
                        background-color: #466EFC; 
                        color: #FFFFFF;                       
                        border-radius:20px; 
                        font-size:16px;             
                        "
                      size="sm"
                      class="mb-2 col-12"
                      @click="GoToEwallet()"
                    ><strong>RM 30</strong></CButton>
                  </div>
                </CCard>
              </CCol>                 
            </CRow>

            <div>
              <CButton
                color="success"
                class="custom-btn mt-1 mb-4"
                size="lg"
                block
                :disabled="isDisabled"
                @click="GoToDashBoard"
              >Close</CButton>
            </div>

          </CCol>
        </CContainer>
      </CCol>
      
    </CCard>

    
  </div>
</template>

<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import backgroundUrl from "../assets/img/backgroundTutor.png";
import backgroundBanner from "../assets/img/bgApps.jpg";
import Mainlayout from "../containers/TheHeaderStudentCustom.vue";
import _ from "lodash";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-timepicker", VueTimepicker);
Vue.component("v-select", vSelect);
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
export default {
  name: "Login",
  components: {
    PulseLoader,
    Mainlayout
  },
  data() {
    return {
      backgroundBanner,      
    };
  },
  async mounted() {},
  computed: {},
  methods: {
    GoToEwallet() {
      this.$router.push(
        "/QuizStudentEwallet"
      );
    },
    GoToDashBoard() {
      this.$router.push(
        "/QuizStudentDashboard?userId=" +
          this.$route.query.userId +
          "&studentId=" +
          this.$route.query.studentId
      );
    },
  }
};
</script>

<style>
.coin_card{
  background: rgb(179,155,255);
background: linear-gradient(180deg, rgba(179,155,255,0.5914740896358543) 10%, rgba(255,220,160,0.8015581232492998) 60%);
}

.coin_card2{
 background: rgb(255,220,160);
background: linear-gradient(180deg, rgba(255,220,160,0.8015581232492998) 40%, rgba(179,155,255,0.6194852941176471) 80%);
}
</style>


